import React from "react";
import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import TotalOrders from "../../images/orders icon.svg";
import OpenOrders from "../../images/open orders.svg";
import StoreViews from "../../images/store views.svg";
import OrderValue from "../../images/order value.svg";

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#4eaf51",
  [theme.breakpoints.down("lg")]: {
    fontSize: "15px",
  },
}));
const ItemBox = styled(Box)(({ theme }) => ({
  padding: "12px",
  background: "#FFFFFF",
  borderRadius: "9px",
  height: "90px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    fontSize: "120px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "100px",
  },
}));

function Cards({ info }) {
  return (
    <Grid container spacing={{ xs: 2, md: 4 }}>
      <Grid item md={3} sm={6} xs={12}>
        <ItemBox>
          <Title>Total Orders</Title>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Title sx={{ color: "#333322" }}>
              {info?.countTotalOrders || 0}
            </Title>
            <img src={TotalOrders} alt="" />
          </Stack>
        </ItemBox>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <ItemBox>
          <Title>Open Orders</Title>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Title sx={{ color: "#333322" }}>
              {info?.countOpenOrders || 0}
            </Title>
            <img src={OpenOrders} alt="" />
          </Stack>
        </ItemBox>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <ItemBox>
          <Title>Store Views</Title>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Title sx={{ color: "#333322" }}>00</Title>
            <img src={StoreViews} alt="" />
          </Stack>
        </ItemBox>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <ItemBox>
          <Title>Order Value Recieved</Title>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Title sx={{ color: "#333322" }}>
              {info?.amountOpenOrders || 0}
            </Title>
            <img src={OrderValue} alt="" />
          </Stack>
        </ItemBox>
      </Grid>
    </Grid>
  );
}

export default Cards;
